/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'
import { paragraphSmall } from 'src/components/css'

type SelectTabProps = {
  onChange: (e: any) => void
  options: {
    label: string
    value: string
    disabled?: boolean
  }[]
  value?: string
}

const SelectTab = ({ options, onChange, value }: SelectTabProps) => {
  return (
    <div
      css={css`
        display: inline-flex;
        align-items: flex-start;
        border-radius: 8px;
        border: 1px solid ${colors.NEUTRAL_100};
      `}
    >
      {options.map((option, index) => (
        <button
          css={css`
            ${paragraphSmall}
            display: flex;
            padding: 8px 40px;
            justify-content: center;
            align-items: center;
            gap: 8px;
            background: ${option.value === value
              ? colors.SECONDARY_300
              : colors.SECONDARY_400};
            color: ${colors.WHITE};
            font-weight: ${option.value === value ? '700' : '400'};
            border-top-left-radius: ${index === 0 ? '8px' : '0px'};
            border-bottom-left-radius: ${index === 0 ? '8px' : '0px'};
            border-top-right-radius: ${index === options.length - 1
              ? '8px'
              : '0px'};
            border-bottom-right-radius: ${index === options.length - 1
              ? '8px'
              : '0px'};
            text-transform: uppercase;
          `}
          onClick={() => onChange(option.value)}
          key={option.value}
        >
          {option.label}
        </button>
      ))}
    </div>
  )
}

export default SelectTab
